import React from 'react';
import { Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

/**
 * BookProgress Component
 * Shows progress through the book creation workflow (separate from e-commerce checkout)
 *
 * Steps:
 * 1. Input        - Provide character details and story parameters
 * 2. Story Review - Review and approve generated story
 * 3. Pages Review - Review and approve all illustrations (cover + interior)
 * 4. Final Review - Review complete book and save/order
 */
function BookProgress({ step1, step2, step3, step4, jobId }) {
    return (
        <Nav className='justify-content-center mb-4' style={{ borderBottom: '2px solid #e9ecef', paddingBottom: '1rem' }}>
            <Nav.Item>
                {step1 ? (
                    <Nav.Link disabled className='text-success fw-bold' style={{ opacity: 1 }}>
                        <i className="fas fa-check-circle me-1"></i>
                        Input
                    </Nav.Link>
                ) : (
                    <Nav.Link disabled className='text-muted'>
                        1. Input
                    </Nav.Link>
                )}
            </Nav.Item>

            <Nav.Item>
                {step2 ? (
                    <Nav.Link disabled className={`fw-bold ${step1 ? 'text-primary' : 'text-success'}`} style={{ opacity: 1 }}>
                        {step1 && <i className="fas fa-check-circle me-1"></i>}
                        Story Review
                    </Nav.Link>
                ) : (
                    <Nav.Link disabled className='text-muted'>
                        2. Story Review
                    </Nav.Link>
                )}
            </Nav.Item>

            <Nav.Item>
                {step3 ? (
                    <Nav.Link disabled className={`fw-bold ${step2 ? 'text-primary' : 'text-success'}`} style={{ opacity: 1 }}>
                        {step2 && <i className="fas fa-check-circle me-1"></i>}
                        Illustrations Review
                    </Nav.Link>
                ) : (
                    <Nav.Link disabled className='text-muted'>
                        3. Illustrations Review
                    </Nav.Link>
                )}
            </Nav.Item>

            <Nav.Item>
                {step4 ? (
                    <Nav.Link disabled className={`fw-bold ${step3 ? 'text-primary' : 'text-success'}`} style={{ opacity: 1 }}>
                        {step3 && <i className="fas fa-check-circle me-1"></i>}
                        Final Review
                    </Nav.Link>
                ) : (
                    <Nav.Link disabled className='text-muted'>
                        4. Final Review
                    </Nav.Link>
                )}
            </Nav.Item>
        </Nav>
    );
}

export default BookProgress;
